<template>
  <div>
    <section v-if="content.body.length">
      <template v-if="content.title != null">
        <div class="mb-2 pt-5">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="headline" v-text="content.title"></div>
              <div
                class="subtitle-1 grey--text text--darken-2"
                v-text="content.subtitle"
              ></div>
            </div>
          </div>
        </div>
      </template>
      <v-chip-group column active-class="primary--text">
        <v-chip
          @click="navigate(tag)"
          label
          outlined
          :large="$vuetify.breakpoint.mdAndUp"
          v-for="tag of content.body"
          :key="`tag_${tag._id}`"
          >{{ tag.title }}</v-chip
        >
      </v-chip-group>
      <template v-if="content.footerButton != null">
        <div class="mt-3">
          <v-btn :color="$buttonColor">
            More
            <v-icon right small>far fa-chevron-right</v-icon>
          </v-btn>
        </div>
      </template>
    </section>
    <section v-else>
      <div class="mb-2 pt-5">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="headline" v-text="content.title"></div>
            <div
              class="subtitle-1 grey--text text--darken-2"
              v-text="content.subtitle"
            ></div>
          </div>
        </div>
      </div>
      <v-row class="px-2 mb-4 text-center body-2 grey--text">
        <v-col cols="12"> ไม่มีข้อมูล </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
export default {
  name: "tag_listview",
  props: ["content"],
  data: () => ({}),
  mounted() {
    // console.log(this.content);
  },
  methods: {
    more() {},
    navigate(item) {
      this.$router.push({
        name: "course",
        query: {
          skill: item._id,
          page: 1,
          limit: 10,
          sort: "created_at",
          sortBy: -1,
          title: item.title,
        },
        params: {
          title: item.title,
        },
      });
    },
  },
};
</script>